import React from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const PassengerDashboard = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Welcome, {user?.displayName || 'Passenger'}!</h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {[
            { label: 'Active Bookings', value: 2, color: 'bg-blue-500' },
            { label: 'Upcoming Journeys', value: 1, color: 'bg-green-500' },
            { label: 'Completed Trips', value: 5, color: 'bg-purple-500' },
          ].map((stat, idx) => (
            <div key={idx} className={`${stat.color} text-white p-6 rounded-lg shadow-lg`}>
              <p className="text-sm opacity-90">{stat.label}</p>
              <p className="text-3xl font-bold">{stat.value}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Link to="/search" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition flex items-center space-x-4">
            <span className="text-3xl">{'\uD83D\uDD0D'}</span>
            <div>
              <p className="font-semibold">Search & Book</p>
              <p className="text-sm text-gray-600">Find and book trains</p>
            </div>
          </Link>

          <Link to="/bookings" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition flex items-center space-x-4">
            <span className="text-3xl">{'\uD83C\uDFAB'}</span>
            <div>
              <p className="font-semibold">My Bookings</p>
              <p className="text-sm text-gray-600">View all bookings</p>
            </div>
          </Link>

          <Link to="/profile" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition flex items-center space-x-4">
            <span className="text-3xl">{'\uD83D\uDC64'}</span>
            <div>
              <p className="font-semibold">My Profile</p>
              <p className="text-sm text-gray-600">Edit profile info</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PassengerDashboard;
